<template>
  <div class="img" >
   <div class="img-hover"
        @dragenter.stop.prevent="handleDragEnter"
        @dragover.stop.prevent="handleDragOver"
        @dragleave.stop.prevent="handleDragLeave"
        @drop.stop.prevent="handleDrop"
   >
       <div class="a-mask" v-if="disabled && value">
         <img  mode="aspectFill" @click="handlePreviewBtn" :src="getFileAccessHttpUrl(urlList[chooseIdx])" :style="{'width':width+'px','height':height+'px'}">
       </div>
     <a-upload
       ref="aupload"
       name="file"
       listType="picture-card"
       :multiple="isMultiple"
       :action="uploadAction"
       :headers="headers"
       :data="{biz:bizPath}"
       :beforeUpload="beforeUpload"
       :disabled="(value!=null && value!='' && value!=undefined) || disabled || !allowEdit"
       :isMultiple="isMultiple"
       :showUploadList="isMultiple"
       v-if="!disabled || !value"
       @dragover="handleDragOver"
       @drop="handleDrop"
       @change="handleChange">

       <div class="img-box"   :style="{'width':width+'px','height':height+'px'}">
         <div class="img-item image-mask-container" style="position: relative;" v-if="chooseIdx!=-1"  :style="{width:width+'px',height:height+'px'}">
<!--           <div class="delete-img" v-if="!disabled && value"  @click.stop="handleDelete1">-->
<!--             <img   src="@/assets/driver/delete.png"/>-->
<!--           </div>-->
           <img class="base-image"   mode="aspectFill" :src="getFileAccessHttpUrl(urlList[chooseIdx])" :style="{'width':width+'px','height':height+'px'}">
           <!-- 遮罩层 + 悬浮按钮 -->
           <div class="hover-mask">
             <!-- 半透明黑色遮罩背景 -->
             <div class="mask-bg" @click.stop="mask"></div>
             <!-- 按钮组 -->
             <div class="float-buttons">
               <div @click.stop="handleDelete1">
                 <icon-font  type="icon-shanchu-copy-copy"></icon-font>
                 <div class="img-btn">删除</div>
               </div>
               <div @click.stop="handlePreviewBtn">
                 <icon-font  type="icon-chakan1"></icon-font>
                 <div class="img-btn">查看</div>
               </div>
               <div @click.stop="tranferToRight">
                 <icon-font  type="icon-xiangyouyidong"></icon-font>
                 <div class="img-btn">移除</div>
               </div>
             </div>
           </div>
         </div>
         <div class="upload-box" v-else :style="{height:height+'px'}" >
            <a-icon type="plus" v-if="!disabled" />
           <div class="text" v-if="!disabled">上传</div>
         </div>
       </div>
     </a-upload>
   </div>
    <div ref="viewer" class="images" v-viewer="viewerOptions" style="display: none;">
      <img :src="previewImage" :key="previewImage">
    </div>
  </div>


</template>

<script>
import { getAccessToken } from '@/utils/token'
  import Vue from 'vue'
  import { ACCESS_TOKEN } from "@/store/mutation-types"
  import { getFileAccessHttpUrl,getAction } from '@/api/manage'



  const uidGenerator=()=>{
    return '-'+parseInt(Math.random()*10000+1,10);
  }
  const getFileName=(path)=>{
    if(path.lastIndexOf("\\")>=0){
      let reg=new RegExp("\\\\","g");
      path = path.replace(reg,"/");
    }
    return path.substring(path.lastIndexOf("/")+1);
  }
  export default {
    name: 'JImageUploadNew',
    data(){
      return {
        uploadAction:window._CONFIG['domianURL']+"/sys/common/upload",
        uploadLoading:false,
        picUrl:false,
        headers:{},
        fileList: [],
        urlList:[],
        previewImage:"",
        previewVisible: false,
        scanFlag:false,
        tranfrom:1,
        viewerOptions:{
          title: false, // 显示当前图片的标题(显示alt属性或从URL解析出的图片名称)[布尔值/数字/方法/数组：默认true]
          toolbar: true, // 显示工具栏、自定义工具栏[布尔值/数字/对象：默认true]
          movable: true, // 图片是否可移动[布尔值：默认true]
          zoomable: true, // 图片是否可缩放[布尔值：默认true]
          url: 'src' // 播放时图片地址 URL 来源。[字符串/方法：默认src](如果是字符串，则应该是每个图像元素的属性之一。 如果是方法，则应该返回一个有效的图像URL)
        },
        imgLoading:false,
        chooseIdx:0,
        showMask:false,
        getFileAccessHttpUrl:getFileAccessHttpUrl
      }
    },
    props:{
      text:{
        type:String,
        required:false,
        default:"上传"
      },
      /*这个属性用于控制文件上传的业务路径*/
      bizPath:{
        type:String,
        required:false,
        default:"temp"
      },
      value:{
        type:[String,Array],
        required:false
      },
      disabled:{
        type:Boolean,
        required:false,
        default: false
      },
      isMultiple:{
        type:Boolean,
        required:false,
        default: true
      },
      //update-begin-author:wangshuai date:20201021 for:LOWCOD-969 新增number属性，用于判断上传数量
      number:{
        type:Number,
        required:false,
        default:0
      },
      width:{
        type:Number,
        required:false,
        default:350
      },
      height:{
        type:Number,
        required:false,
        default:210
      },scan:{
        type:String,
        required:false,
        default: ''
      },
      url:{
        type:String,
        required:false,
        default: ''
      },allowEdit:{
        type:Boolean,
        default: true
      },tzType:{
        type:Number,
        default: 1
      }
      //update-end-author:wangshuai date:20201021 for:LOWCOD-969 新增number属性，用于判断上传数量
    },
    watch:{
      value: {
        handler(val,oldValue) {
          if (val instanceof Array) {
            this.initFileList(val.join(','))
          } else {
            this.initFileList(val)
          }
          if(!val || val.length==0) {
            this.picUrl = false;
            this.chooseIdx = -1;
          }else{
            if(this.chooseIdx==-1){
              this.chooseIdx = 0
            }
          }
          if(this.scan && val.split(",").length==1){
            this.scanPic()
          }
        },
        //立刻执行handler
        immediate: true
      }
    },
    created(){
      const token = getAccessToken();
      this.headers = {"X-Access-Token":token}
    },
    methods:{
      mask(){

      },
      initFileList(paths) {
        if (!paths || paths.length == 0) {
         // let fileList = [];
          this.urlList = [1];
          this.urlList.splice(0,1)
          return;
        }
        this.picUrl = true;
        let fileList = [];
        let urlList = []
        let arr = paths.split(",")
        for (var a = 0; a < arr.length; a++) {
          let url = arr[a];
          fileList.push({
            uid: uidGenerator(),
            name: getFileName(arr[a]),
            status: 'done',
            url: url,
            response: {
              status: "history",
              message: arr[a]
            }
          })
          urlList.push(url)
        }
        this.fileList = fileList
        this.urlList = urlList;
      },
      beforeUpload: function(file){
        var fileType = file.type;
        if(fileType.indexOf('image')<0 ){
          this.$message.warning('请上传图片');
          return false;
        }
        this.callbackImgState(1);
      },
      handleChange(info) {
        this.picUrl = false;
        let taht = this;
        let fileList = info.fileList
        //update-begin-author:wangshuai date:20201022 for:LOWCOD-969 判断number是否大于0和是否多选，返回选定的元素。
        if(this.number>0 && this.isMultiple){
          fileList = fileList.slice(-this.number);
        }
        //update-end-author:wangshuai date:20201022 for:LOWCOD-969 判断number是否大于0和是否多选，返回选定的元素。
        if(info.file.status==='done'){
          if(info.file.response.success){
            this.picUrl = true;
            fileList = fileList.map((file) => {
              if (file.response) {
                file.url = file.response.message;

              }
              return file;
            });
          }

          this.callbackImgState(-1);
          //this.$message.success(`${info.file.name} 上传成功!`);
        }else if (info.file.status === 'error') {
          this.$message.error(`${info.file.name} 上传失败.`);
          this.callbackImgState();
        }else if(info.file.status === 'removed'){
          //this.handleDelete(info.file)
          // console.log(111)
          // this.handleDelePathChange();
        }
        this.fileList = fileList
        if(info.file.status==='done' || info.file.status === 'removed'){

          if(info.file.status==='done'){

            this.handlePathChange(this.fileList[this.fileList.length-1])
          }else{
            this.handleDelePathChange();
          }
         // console.log(this.fileList)
          info.fileList = this.fileList;


        }

      },
      // 预览
      handlePreview (file) {
        this.previewImage = file.url || file.thumbUrl
        this.previewVisible = true
        this.$refs.viewer.$viewer.show();
      },
      // 预览
      handlePreviewBtn () {

        this.previewImage = getFileAccessHttpUrl(this.urlList[this.chooseIdx]);
        this.previewVisible = true
        this.$refs.viewer.$viewer.show();
      },deletePic(){
        let file = this.fileList[0]
        file.status = 'removed';
        let info ={
          file:file
        }
        this.handleChange(info);
      },
      getAvatarView(){
        if(this.fileList.length>0){
          let url = this.fileList[0].url

          if(!url.indexOf("http")!=-1){
           url = getFileAccessHttpUrl(url);
          }
          let img = new Image();
          img.src = url;
          let taht = this;
          img.onload = function(){
              taht.imgLoading = true
          }
          return url;
        }
      },
     async handlePathChange(file){
        let uploadFiles = this.urlList
        if(uploadFiles){
            if(this.chooseIdx==-1){
              uploadFiles.push(file.response.message);

              this.chooseIdx = uploadFiles.length-1;
            }else{
              uploadFiles[this.chooseIdx] = file.response.message;
            }
        }
        let path =''
        if(uploadFiles.length>0){
          path = uploadFiles.join(",")
        }
       await this.$emit('change', path);
        if(this.tzType===2){
          this.handleDelete1();
        }

      },handleDelePathChange(){
        let uploadFiles = this.fileList
        let path = ''
        if(!uploadFiles || uploadFiles.length==0){
          path = ''
        }
        let arr = [];
        if(uploadFiles){
            for(let a=0;a<uploadFiles.length;a++){
              // update-begin-author:taoyan date:20200819 for:【开源问题z】上传图片组件 LOWCOD-783
              if(uploadFiles[a].status === 'done' ) {
                arr.push(uploadFiles[a].response.message)
              }else{
                continue;
              }
            }

        }

        if(arr.length>0){
          path = arr.join(",")
        }
        console.log(path)
        this.$emit('change', path);
      },
      handleDelete1(){
        if(this.chooseIdx==-1){
          return;
        }
        let file = null;
        for(let c in this.fileList){
          if(this.urlList[this.chooseIdx].indexOf(this.fileList[c].url)!=-1){
            file = this.fileList[c];

          }
        }
        if(file){
          file.status = 'removed';
          let info = {
            file:file,
            fileList:this.fileList
          }
          this.urlList.splice(this.chooseIdx,1);

          if(this.chooseIdx>this.urlList.length-1){
            this.chooseIdx = this.chooseIdx-1;
          }else if(this.urlList.length==0){
            this.chooseIdx = -1;
          }else{

          }
          this.handleChange(info);
        }

      },
      handleCancel() {
        this.close();
        this.previewVisible = false;
      },
      close () {
        console.log( this.fileList)
      },scanPic(){
        let that = this;

        if( this.urlList &&  this.urlList.length){
          that.scanFlag = true;
          let path =  this.urlList[this.chooseIdx];
          if(path.indexOf("https://ht.dimoclub.com")!=-1){
            path = path.replace("https://ht.dimoclub.com/dmapi/sys/common/static/","")
          }
          // if(path.indexOf("http")==-1){
          //   path = getFileAccessHttpUrl(path);
          // }
         // path  = path.replace();
          path = decodeURIComponent(path)
          getAction("/dm/baiDuOcr/getOcrInfo",{"imgPath":path,"type":this.scan}).then((res)=>{
            if(res.success){
              this.$message.success("识别成功");
              that.$emit("scanOk",res.result);
              //that.scanFlag = false;
            }else{
              this.$message.warning("识别失败");
            }
          }).finally(() => {
            that.scanFlag = false;
          })
        }

      },callbackImgState(num){

        this.$emit("getImgState",num);
      },toTranfrom(){
        if(this.tranfrom>=4){
          this.tranfrom = 1;
        }else{
          this.tranfrom++;
        }
      },handleDragOver(e){
        e.preventDefault(); // 阻止浏览器默认的拒绝拖拽行为
        e.stopPropagation(); // 阻止事件冒泡到组件内部
        this.isDragging = true;
        e.dataTransfer.dropEffect = 'copy'; // 明确设置放下效果
        return false; // 额外返回false增强兼容性
      },handleDrop(e){
        // 先打印日志，确认事件触发
        console.log('drop事件已执行！', e);

        e.preventDefault();
        e.stopPropagation();
        this.isDragging = false;

        // 获取拖拽数据（兼容多格式）
        let imgUrl = e.dataTransfer.getData('text/uri-list') || e.dataTransfer.getData('text/plain');
        if (!imgUrl || !imgUrl.startsWith('http')) {
          return;
        }
        if(!this.disabled){
          //imgUrl = getFileAccessHttpUrl(imgUrl);
          this.$emit('setValue', imgUrl,this.bizPath);
          // if(this.sacn){
          //   this.scanPic();
          // }
        }

      },handleDragEnter(e){
        e.preventDefault();
        e.stopPropagation();
        this.isDragging = true;
        e.dataTransfer.dropEffect = 'copy';
      }, handleDragLeave(e) {
        e.preventDefault();
        e.stopPropagation();
        // 防止鼠标移到子元素时误触发
        // if (!this.$refs.aupload.contains(e.relatedTarget)) {
        //   this.isDragging = false;
        // }
      },tranferToRight(){
        this.$emit('tranferToRight');
      }
    },
    model: {
      prop: 'value',
      event: 'change'
    }
  }
</script>

<style scoped>
  /* update--begin--autor:lvdandan-----date:20201016------for：j-image-upload图片组件单张图片详情回显空白
  * https://github.com/zhangdaiscott/jeecg-boot/issues/1810
  * https://github.com/zhangdaiscott/jeecg-boot/issues/1779
  */
  @import '~@assets/less/upload/upload.less';
  .a-mask img{
    border-radius:12px;
    object-fit: cover;
    object-position: center;
    margin-bottom: 24px;
  }
  .mask-box{
    display: flex;
    justify-content: space-around;

    position: absolute;
    z-index: 999;

  }
  .img-box{
    /*width: 350px;*/
    /*height: 210px;*/
    background: rgba(230, 237, 245, 1);
    border-radius:12px;
  }

  .img-item img{
    /*width: 350px;*/
    /*height: 210px;*/
    object-fit: cover; object-position: center;
    border-radius:12px;
  }
  .upload-box{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color: #2A82E4;
  }
  .add-img{
    color: #000;
    background: rgba(255, 255, 255, 1);
    font-size: 20px;
    line-height: 30px;
    height: 48px !important;
    margin-left: 6px;
    border-radius: 5px !important;
    width: 48px !important;
  }
  .small-box{
    margin-top: -14px;
    color: rgba(125, 133, 146, 1);
    font-size: 14px;
  }

  .small-img{
    display: flex;
    /*width: 350px;*/

  }
  .small-item{
    width: 48px;
    height: 48px;
    margin-right: 28px;
    line-height: 36px;
    cursor: pointer;
  }
  .small-item img{
    width: 48px;
    height: 48px;
    border-radius: 6px;
  }
  .small-item .active{
    border: 4px solid rgba(63, 140, 255, 1) !important;
  }
  .add-upload{
    background: rgba(230, 237, 245, 1) !important;
    margin-left: 0 !important;
  }
  .icon-font{
    color: #0A1629;
    background: #fff;
    width: 36px;
    height: 36px;
    font-size: 24px;
    line-height: 36px;
    border-radius: 6px;
    cursor: pointer;
  }

  .delete-img{
    background: #fff;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    position: absolute;
    right: 2px;
    top: 2px;
    text-align: center;
    line-height: 24px;
    cursor: pointer;
  }
  .delete-img img{
    width: 20px;
    height: 20px;
  }

  /deep/ .imgupload .ant-upload-select{display:block}
  /deep/ .imgupload .ant-upload.ant-upload-select-picture-card{ width:120px;height: 120px;

  border: none !important;}
  /deep/ .imgupload .iconp{padding:32px;}
  /deep/ .ant-modal-wrap1{
    left: -30%;
  }
  /deep/ .ant-modal-wrap2{
    left: -30%;
    transform: rotate(90deg);
  }
  /deep/ .ant-modal-wrap3{
    left: -30%;
    transform: rotate(180deg);
  }
  /deep/ .ant-modal-wrap4{
    left: -30%;
    transform: rotate(270deg);
  }
  /deep/ .ant-upload.ant-upload-select-picture-card > .ant-upload{
    padding: 0 !important;
  }
  .icons-list >>> .anticon {
    margin-right: 6px;
    font-size: 24px;

  }
  /deep/ .ant-upload.ant-upload-select-picture-card{
    border: none !important;
  }
  /deep/ .ant-upload-list{
    display: none;
  }
</style>

